import { OrderByFieldApproveEmployees, SearchApprovesContextValue, SearchFilters } from './types'
import qs from 'qs'
import { UserSearchRequestBody } from '../api/types'

export const stringifyFiltersApproveEmployees: (
    filters: Pick<SearchApprovesContextValue, 'newLevels' | 'competencies' | 'searchString' | 'orderBy'>
) => string = (filters) => {
    const { newLevels, competencies, searchString, orderBy } = filters
    const params: Record<any, any> = {
        newLevels: (newLevels as number[]).map((s: number) => s.toString()).join('|'),
        competencies: competencies,
    }
    if (orderBy) {
        params.orderBy = stringifyOrderBy(orderBy)
    }
    if (searchString) {
        params.text = searchString
    }

    // if encode false, website cannot navigate back
    return qs.stringify(params, { encode: true, arrayFormat: 'repeat' })
}

export const stringifyOrderBy: (orderBy: OrderByFieldApproveEmployees) => string = (orderBy) =>
    [orderBy.field, orderBy.asc].join('|')

export const parseFilters: (
    searchParams: URLSearchParams
) => Pick<SearchApprovesContextValue, 'newLevels' | 'competencies' | 'searchString' | 'orderBy'> = (
    searchParams
) => {
    const q = qs.parse(searchParams.toString())

    return {
        newLevels: q.newLevels
            ? Array.isArray(q.newLevels)
                ? (q.newLevels as string[]).map((value: string) => +value)
                : []
            : [],
        competencies: q.competencies
            ? ((Array.isArray(q.competencies) ? q.competencies : [q.competencies]) as string[])
            : [],
        searchString: (q.text as string) || '',
        orderBy: q.orderBy ? parseOrderBy(q.orderBy as string) : null,
    }
}

export const parseOrderBy: (orderBy: string) => OrderByFieldApproveEmployees = (orderBy) => {
    const orderByObj = orderBy.split('|')
    return {
        field: orderByObj[0],
        asc: orderByObj[1] === 'true',
    } as OrderByFieldApproveEmployees
}

const defineIfExist: (obj: Record<any, any>, value: any, propertyName: string) => void = (
    obj,
    value,
    propertyName
) => {
    if (value && !(Array.isArray(value) && value.length === 0)) {
        obj[propertyName] = value
    }
}

export const constructSearchBody = ({
    searchString,
    newLevels,
    competencies,
    orderBy,
    offset,
}: SearchFilters): UserSearchRequestBody => {
    const body: UserSearchRequestBody = {
        text: searchString,
        page_size: 20,
        page_offset: offset,
    }
    defineIfExist(body, newLevels, 'new_levels')
    defineIfExist(body, competencies, 'competencies')
    if (orderBy) {
        body.order_by = [orderBy] as OrderByFieldApproveEmployees[]
    }
    return body
}
